import { Fragment } from "react";
import { Link } from "react-router-dom";

import { classNames } from "utils/helpers";

export type BreadcrumbItem = {
  label: string;
  to?: string;
};

type Props = {
  items: BreadcrumbItem[];
  className?: string;
};

export default function PageBreadcrumb({ items, className }: Props) {
  if (!items.length) {
    return null;
  }

  return (
    <div className={classNames("bg-brand-green-dark", className)}>
      <div className="mx-auto flex max-w-7xl items-center justify-between px-8 py-3">
        <nav
          aria-label="Breadcrumb"
          className="flex items-center gap-5 text-sm"
        >
          {items.map((item, index) => (
            <Fragment key={`${item.label}-${index}`}>
              {index > 0 && item.label && (
                <span className="text-white/60" aria-hidden="true">
                  {" / "}
                </span>
              )}
              {item.to ? (
                <span className="font-medium text-white">
                  <Link
                    to={item.to}
                    className="text-white underline-offset-4 hover:text-brand-lime hover:underline"
                  >
                    {item.label}
                  </Link>
                </span>
              ) : (
                <span className="text-white/80">{item.label}</span>
              )}
            </Fragment>
          ))}
        </nav>
      </div>
    </div>
  );
}
